<mat-toolbar class="subtitulo">Cadastro de Cargos</mat-toolbar>

<div class="painel-principal" style="padding: 10px;">
        <form #formCadastro="ngForm">

                <!-- DADOS INICIAIS -->
                <mat-toolbar class="titulopartes">Dados</mat-toolbar>
                <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>


                        <mat-form-field fxFlex="35%" fxFlexOffset="20px">
                                <input matInput maxlength="200" name="nome" placeholder="Nome do Cargo"
                                        [(ngModel)]="cargo.nome">
                        </mat-form-field>

                        <mat-form-field fxFlex="25%">
                                <mat-label>Tipo Cargo:</mat-label>
                                <mat-select [(ngModel)]="cargo.tipoCargo" name="tipoCargo" required>
                                        <mat-option></mat-option>
                                        <mat-option *ngFor="let m of tiposCargo.tipos" [value]="m.tipo">
                                                {{m.descricao}}
                                        </mat-option>
                                </mat-select>
                        </mat-form-field>
                        
                        <mat-form-field fxFlex="20%">
                                <input currencyMask [(ngModel)]="cargo.valorRemuneracao" name="remuneracao" placeholder="Remuneração:" matInput
                                        maxlength="13" [options]="{ prefix: '', thousands: '.', decimal: ',' }" />
                                <span matPrefix>R$&nbsp;</span>
                        </mat-form-field>

                </div>

                <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

                        <mat-form-field fxFlexOffset="20px" fxFlex="20%" fxFlexOffset="20px">
                                <input matInput maxlength="2" name="qtHoras" placeholder="Carga Horária"
                                        [(ngModel)]="cargo.qtdHoras">
                        </mat-form-field>

                        <mat-form-field fxFlex="80%">
                                <mat-label>CBO</mat-label>
                                <mat-select [(ngModel)]="cargo.cbo.id" name="cbo">
                                        <mat-option></mat-option>
                                        <mat-option *ngFor="let m of cbos" [value]="m.id">
                                                {{m.numero}} - {{m.descricaoTipo}}
                                        </mat-option>
                                </mat-select>
                        </mat-form-field>

                </div>
                <div fxLayout="row" fxLayoutGap="50px" fxFlexFill>
                        <mat-form-field fxFlexOffset="20px" fxFlex="80">
                                <mat-label>Escolaridade</mat-label>
                                <mat-select [(ngModel)]="cargo.grausInstrucao.id" name="grausInstrucao">
                                        <mat-option></mat-option>
                                        <mat-option *ngFor="let m of grausInstrucao" [value]="m.id">
                                                {{m.descricao}}
                                        </mat-option>
                                </mat-select>
                        </mat-form-field>

                    <div>
                        <mat-checkbox color="primary"
                                      title="SUAS"
                                      name="cargoSuas"
                                      [(ngModel)]="cargo.suas"
                                      style="margin-top: 20px;">
                            SUAS
                        </mat-checkbox>
                    </div>
                </div>

                <div fxLayout="row" fxLayoutGap="50px" fxFlexFill>

                        <mat-form-field style="margin: 0 0 0 20px" fxFlexOffset="20px" fxFlex="45%"
                                appearance="outline">
                                <mat-label>Curso/Área de Conhecimento</mat-label>
                                <textarea #dsPerfilProfissional matInput name="descricaoPerfilProfissional"
                                        [(ngModel)]="cargo.descricaoPerfilProfissional" cdkTextareaAutosize
                                        #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3"
                                        maxlength="2000"></textarea>
                                <mat-hint align="end">{{dsPerfilProfissional.value.length}} / 2000</mat-hint>
                        </mat-form-field>

                        <mat-form-field style="margin: 0 0 0 20px" fxFlex="45%" appearance="outline">
                                <mat-label>Descrição das atividades</mat-label>
                                <textarea #dsResumoAtividades matInput name="descricaoResumoAtividades"
                                        [(ngModel)]="cargo.descricaoResumoAtividades" cdkTextareaAutosize
                                        #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3"
                                        maxlength="2000"></textarea>
                                <mat-hint align="end">{{dsResumoAtividades.value.length}} / 2000</mat-hint>
                        </mat-form-field>
                </div>


        </form>

        <!-- BOTOES -->
        <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
                fxFlexFill>
                <button *ngIf="!isAtualizar && mostrarBotaoCadastrar" mat-raised-button name="botaoConfirmar"
                        fxFlex="20%" color="primary" [disabled]="formCadastro.invalid" (click)="cadastrar()"> Cadastrar
                </button>

                <button *ngIf="isAtualizar && mostrarBotaoAtualizar" mat-raised-button name="botaoConfirmar"
                        fxFlex="20%" color="primary" [disabled]="formCadastro.invalid" (click)="atualizar()">
                        Atualizar
                </button>

                <button *ngIf="mostrarBotaoLimpar()" mat-raised-button fxFlex="20%" (click)="limpar()">
                        Limpar
                </button>
                <button mat-raised-button fxFlex="20%" (click)="cancelar()">
                        Cancelar
                </button>

        </div>

</div>